import { create } from "zustand";

type UiState = {
  stealth: boolean;
  setStealth: (b: boolean) => void;
  toggleStealth: () => void;
};

export const useUiStore = create<UiState>((set) => ({
  stealth: false,
  setStealth: (b: boolean) => set({ stealth: b }),
  toggleStealth: () => set((s) => ({ stealth: !s.stealth })),
}));
